<template>
  <div>
    <CRow>
      <CCol sm="12" class="p-0">
        <CCard>
          <div
            class="px-3 d-flex flex-wrap w-100 border-bottom align-items-center"
          >
            <h5 class="flex-grow-1 col-xs-6 my-2">Administrativos</h5>
            <DateSelector
              initDates="week"
              :date="this.initDates"
              @input="e => changeDate(e)"
              class="margi-dates z-custom-2 col-xs-6 my-2"
            />
            <div class="d-flex flex-wrap col-xs-12 my-2">
              <v-select
                class="selector-input"
                :options="cultivos"
                v-model="cropGraphs"
                :loading="isLoadingPage"
                placeholder="Cultivo"
              >
                <template #open-indicator="{ attributes }">
                  <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                </template>
                <template #no-options>Sin resultados.</template>
              </v-select>
              <v-select
                class="selector-input"
                :options="variedadesPorCultivo"
                v-model="variedadGraphs"
                :loading="isLoadingPage"
                placeholder="Variedad"
              >
                <template #open-indicator="{ attributes }">
                  <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                </template>
                <template #no-options>Sin resultados.</template>
              </v-select>
              <v-select
                class="selector-input"
                :options="ubicaciones2"
                v-model="locationGraphs"
                :loading="isLoadingPage"
                placeholder="Ubicacion"
              >
                <template #open-indicator="{ attributes }">
                  <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                </template>
                <template #no-options>Sin resultados.</template>
              </v-select>
            </div>
          </div>
          <CCardBody class="p-0 pt-2">
            <CNav justified variant="tabs">
              <CNavItem :to="{
            name: 'Ingresos'
          }">Ingresos</CNavItem>
              <CNavItem
                :to="{
            name: 'IngresosAcumulados'
          }"
              >Ingresos Acumulados</CNavItem>
              <CNavItem :to="{
            name: 'Egresos'
          }" active>Egresos</CNavItem>
              <CNavItem :to="{
            name: 'EgresosAcumulados'
          }">Egresos Acumulados</CNavItem>
              <CNavItem
                :to="{
            name: 'IndicadoresAdmin'
          }"
              >KPI's Administrativos</CNavItem>
              <CNavItem :to="{
            name: 'Comparativa'
          }">Comparativa</CNavItem>
            </CNav>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <div class="d-flex flex-wrap justify-content-between align-items-center">
      <h1>Egresos</h1>
      <CButtonGroup>
        <CButton @click="changeGrapgh(1)" color="primary">Gastos</CButton>
        <CButton @click="changeGrapgh(3)" color="primary">Gastos por cultivo</CButton>
        <CButton @click="changeGrapgh(2)" color="primary">Gastos por documento</CButton>
      </CButtonGroup>
    </div>

    <div>
      <CRow class="mb-4">
        <CCol sm="12" md="12">
          <CChartBar
            ref="ch"
            style="height:300px"
            :options="{
              maintainAspectRatio: false,
              scales: {
                yAxes: [
                  {
                    ticks: {
                      suggestedMin: 50
                    }
                  }
                ]
              },
              tooltips: {
          callbacks: {
          label: function(tooltipItem, data) {
          var label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
          label += ':  $';
          }
          label += String(tooltipItem.yLabel).replace(/\B(?=(\d{3})+(?!\d))/g, `,`)
          return label;
          }
          }
          }
            }"
            :datasets="data"
            :labels="allDays"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CDataTable
            small
            :loading="isLoadingGraph"
            :items="egresosDiaTabla"
            :fields="fields"
            :noItemsView="noItems"
          ></CDataTable>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
// import { setupCalendar, DatePicker } from "v-calendar";
import { CChartBar } from "@coreui/vue-chartjs";
import vSelect from "vue-select";
import DateSelector from "../../../customComponents/DateSelector";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import axios from "axios";

const fieldsEgresosDia = [
  { key: "fecha", label: "Fecha", _style: "width:33%" },
  { key: "total", label: "Gastos", _style: "width:33%" },
  { key: "acumulado", label: "Gasto Acumulado", _style: "width:33%" }
];

const fieldsEgresosDocumentosDia = [
  { key: "fecha", label: "Fecha", _style: "width:20%" },
  { key: "salidas", label: "Salidas", _style: "width:20%" },
  { key: "labores", label: "Labores", _style: "width:20%" },
  { key: "gastos", label: "Gastos", _style: "width:20%" },
  { key: "acumulado", label: "Gasto Acumulado", _style: "width:20%" }
];
const fieldsEgresosCultivoDia = [
  { key: "fecha", label: "Fecha", _style: "width:10%" }
];

const fieldsCostos = [
  { key: "concepto", label: "Concepto", _style: "width:33%" },
  { key: "categoria_raiz", label: "Categoria", _style: "width:33%" },
  { key: "total", label: "Total", _style: "width:33%" }
];

const fieldsKPI = [
  { key: "nombre", label: "Etapa", _style: "width:16%" },
  { key: "pre_util", label: "Presupuesto utilizado", _style: "width:16%" },
  { key: "presupuesto", label: "Presupuesto", _style: "width:16%" },
  { key: "porcentaje", label: "%", _style: "width:16%" },
  { key: "fecha_inicial", label: "Fecha inicio", _style: "width:18%" },
  { key: "fecha_final", label: "Fecha fin", _style: "width:18%" }
];

export default {
  name: "Egresos",
  components: {
    // "v-date-picker": DatePicker,
    vSelect,
    DateSelector,
    CChartBar
  },

  data() {
    return {
      options: ["hola", "adios"],
      cultivosAll: [],
      lote: null,
      lotes: [],
      lotesAll: [],
      loteSelect: null,
      itemsIngresos: [],
      fieldsEgresosDia,
      fieldsEgresosDocumentosDia,
      fieldsEgresosCultivoDia,
      fields: [],
      itemsProduccion: [],
      itemsCostos: [],
      fieldsCostos,
      itemsKPI: [],
      fieldsKPI,
      isLoadingGraph: false,
      counter: 85,
      lotesPresupuesto: null,
      produccionEq: null,
      entregas: null,
      entregasEq: null,
      costos: null,
      costos_lotes: null,
      isLoadingPage: false,
      isLoteActive: true,
      egresos_dia: [],
      egresosDiaTabla: [],
      dayValues: [],
      cultivos: [],
      cultivo: null,
      variedades: [],
      variedadGraphs: null,
      embalajes: [],
      embalajeGraphs: [],
      ubicaciones2: [],
      ubicacion2: null,
      labels: [],
      color1: "primary",
      color2: "secondary",
      data: [],
      dataBar: [],
      actualGraph: 1,
      cancelSource: null,
      // date selector
      isCustomOpen: false,
      dates: {},
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      selectedDate: {
        // start: new Date(today.getFullYear(), today.getMonth(), 1),
        // start: new Date(2019, 1, 1),
        // end: new Date(today.getFullYear(), today.getMonth() + 1, 0)
        // end: new Date(2020, 2, 11)
      }
    };
  },

  created() {
    this.fetchCombos();
    this.fetchDataGraphs();
  },

  computed: {
    clave_empresa() {
      return this.$store.state.clave_empresa.toUpperCase();
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    datesGraph() {
      return this.$store.state.dateGraphs;
    },
    initDates() {
      return {
        start: moment(this.datesGraph[0]),

        end: moment(this.datesGraph[1])
      };
    },
    cropGraphs: {
      get() {
        return this.$store.state.cropGraphs;
      },
      set(value) {
        this.$store.dispatch("setCropGraph", value);
      }
    },
    locationGraphs: {
      get() {
        return this.$store.state.locationGraphs || this.$store.state.rootLocation;
      },
      set(value) {
        this.$store.dispatch("setLocationGraph", value);
      }
    },
    days() {
      const firstDay = moment(this.selectedDate.start);
      const lastDay = moment(this.selectedDate.end);
      return lastDay.diff(firstDay, "days") + 1;
    },
    allDays() {
      const dates = [];
      const firstDay = moment(this.datesGraph[0]);
      const currentDay = moment(this.datesGraph[0]);
      const lastDay = moment(this.datesGraph[1]);

      if (lastDay.format("YYYY-MM-DD") === firstDay.format("YYYY-MM-DD")) {
        dates.push(firstDay.format("YYYY-MM-DD"));
        return dates;
      }

      while (currentDay.add(1, "days").diff(lastDay) < 0) {
        dates.push(currentDay.clone().format("YYYY-MM-DD"));
      }
      if (dates.length) {
        dates.unshift(firstDay.format("YYYY-MM-DD"));
        dates.push(lastDay.format("YYYY-MM-DD"));
      }
      return dates;
    },
    variedadesPorCultivo() {
      const cultivo = this.cropGraphs
      return cultivo === null ? [] : this.variedades.filter(variedad => {
        return cultivo.label === variedad.cultivo
      });
    },
    embalajesPorCultivo() {
      return this.cropGraphs ? this.cropGraphs.embalajes : []
    },
  },

  watch: {
    datesGraph: function() {
      this.fetchDataGraphs();
    },
    actualGraph: function() {
      this.fetchDataGraphs();
    },
    cropGraphs: function() {
      this.fetchDataGraphs();
      this.variedadGraphs = null
      this.embalajeGraphs = []
    },
    variedadGraphs: function() {
      this.fetchDataGraphs();
    },
    embalajeGraphs: {
      deep: true,
      handler() {
        this.fetchDataGraphs()
      }
    },
    locationGraphs: function() {
      this.fetchDataGraphs();
    },
    ubicacionRaiz: function() {
      this.fetchDataGraphs();
      this.fetchCombos();
    }
  },

  methods: {
    customOpenDateSelector() {
      this.isCustomOpen = !this.isCustomOpen;
    },
    getDate(date) {

      return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    fetchDataGraphs() {
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();

      this.isLoadingGraph = true;
      if (this.actualGraph == 1) {
        this.data = [];
        const indicadores = [
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "costos_dia",
              params: {
                fecha: this.datesGraph,
                ubicaciones: [this.ubicacionRaiz],
                cultivo: this.cropGraphs ? this.cropGraphs.value : "",
                cultivo_id: this.variedadGraphs ? this.variedadGraphs.value : '',
                embalaje: this.embalajeGraphs || [],
                ubicacion_id: this.locationGraphs
                  ? this.locationGraphs.value
                  : ""
              }
            },
            cancelToken: this.cancelSource
          })
        ];

        Promise.all(indicadores)
          .then(([indicador]) => {
            this.egresos_dia = indicador.data;
            // console.table(indicador.data);
            if (this.egresos_dia) {
              this.dayValues = this.allDays.map(day => {
                const actualDay = this.egresos_dia.find(d => d.fecha == day);
                return {
                  fecha: day,
                  total: actualDay ? Number(actualDay.valor.toFixed(2)) : 0
                };
              });
              // console.table(this.dayValues);
              const barValues = this.dayValues.map(day => {
                return day.total;
              });
              this.egresosDiaTabla = this.dayValues.reduce((acum, item) => {
                let val = item.total;
                if (acum.length) {
                  val += acum[acum.length - 1].valor;
                }
                acum.push({
                  ...item,
                  total: `$${String(item.total).replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    `,`
                  )}`,
                  acumulado: `$${val
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, `,`)}`,
                  valor: Number(val.toFixed(2))
                });
                return acum;
              }, []);
              this.dataBar = [
                {
                  data: barValues,
                  backgroundColor: "plum",
                  label: "Costos"
                }
              ];

              barValues
                ? (this.data = [
                    {
                      label: "Egresos",
                      backgroundColor: "rgb(50,31,219,0.9)",
                      data: barValues
                    }
                  ])
                : null;
              // console.log(values);
              this.fields = this.fieldsEgresosDia;
              this.isLoadingGraph = false;
            }
          })
          .catch(err => {
            if (err !== "Stop") {
              this.isLoadingGraph = false;
            }
          });
      } else if (this.actualGraph == 2) {
        this.data = [];
        const indicadores = [
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "costos_dia_documento",
              params: {
                fecha: this.datesGraph,
                ubicaciones: [this.ubicacionRaiz],
                cultivo: this.cropGraphs ? this.cropGraphs.value : "",
                cultivo_id: this.variedadGraphs ? this.variedadGraphs.value : '',
                embalaje: this.embalajeGraphs || [],
                ubicacion_id: this.locationGraphs
                  ? this.locationGraphs.value
                  : ""
              }
            },
            cancelToken: this.cancelSource
          })
        ];

        Promise.all(indicadores)
          .then(([indicador]) => {
            this.egresos_dia = indicador.data;
            // console.table(indicador.data);

            const laborGraphs = this.egresos_dia.filter(
              egr => egr.documento == "labor"
            );
            const gastoGraphs = this.egresos_dia.filter(
              egr => egr.documento == "gasto"
            );
            const salidaGraphs = this.egresos_dia.filter(
              egr => egr.documento == "salida"
            );

            const daysLabors = this.allDays.map(day => {
              const actualDay = laborGraphs.find(d => d.fecha == day);
              return {
                fecha: day,
                total: actualDay ? Number(actualDay.valor.toFixed(2)) : 0
              };
            });
            // console.log(daysLabors);

            const dataLabors = daysLabors.map(day => {
              return day.total;
            });

            const daysGastos = this.allDays.map(day => {
              const actualDay = gastoGraphs.find(d => d.fecha == day);
              return {
                fecha: day,
                total: actualDay ? Number(actualDay.valor.toFixed(2)) : 0
              };
            });

            const dataGastos = daysGastos.map(day => {
              return day.total;
            });

            const daysSalidas = this.allDays.map(day => {
              const actualDay = salidaGraphs.find(d => d.fecha == day);
              return {
                fecha: day,
                total: actualDay ? Number(actualDay.valor.toFixed(2)) : 0
              };
            });

            const dataSalidas = daysSalidas.map(day => {
              return day.total;
            });

            this.egresosDiaTabla = daysLabors.reduce((acum, item, idx) => {
              let val =
                daysSalidas[idx].total +
                daysLabors[idx].total +
                daysGastos[idx].total;
              if (acum.length) {
                val += acum[acum.length - 1].value;
              }
              acum.push({
                ...item,
                salidas: `$${String(daysSalidas[idx].total).replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  `,`
                )}`,
                labores: `$${String(daysLabors[idx].total).replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  `,`
                )}`,
                gastos: `$${String(daysGastos[idx].total).replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  `,`
                )}`,
                acumulado: `$${val
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, `,`)}`,
                value: Number(val.toFixed(2))
              });
              return acum;
            }, []);
            // console.table(this.egresosDiaTabla);

            this.data = [
              {
                data: dataLabors,
                backgroundColor: "rgb(50,31,219,0.9)",
                label: "Labores"
              },
              {
                data: dataGastos,
                backgroundColor: "rgb(51,153,255,0.9)",
                label: "Gastos"
              },
              {
                data: dataSalidas,
                backgroundColor: "rgb(46,184,92,0.9)",
                label: "Salidas"
              }
            ];

            this.fields = this.fieldsEgresosDocumentosDia;
            this.isLoadingGraph = false;
          })
          .catch(err => {
            if (err !== "Stop") {
              this.isLoadingGraph = false;
            }
          });
      } else if (this.actualGraph == 3) {
        this.data = [];
        const indicadores = [
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "costos_dia_cultivo",
              params: {
                fecha: this.datesGraph,
                ubicaciones: [this.ubicacionRaiz],
                cultivo: this.cropGraphs ? this.cropGraphs.value : "",
                cultivo_id: this.variedadGraphs ? this.variedadGraphs.value : '',
                embalaje: this.embalajeGraphs || [],
                ubicacion_id: this.locationGraphs
                  ? this.locationGraphs.value
                  : ""
              }
            },
            cancelToken: this.cancelSource
          })
        ];

        Promise.all(indicadores)
          .then(([indicador]) => {
            const dataSets = [];
            const dataSetsValues = [];
            const tableValues = [];
            this.egresos_dia = indicador.data;
            // console.table(indicador.data);
            let cultivosSet = new Set(
              this.egresos_dia.map(item => item.cultivo)
            );
            const cultivos = Array.from(cultivosSet);
            // console.log(cultivos);

            cultivos.forEach(cul => {
              const cultivosValues = this.egresos_dia.filter(
                item => item.cultivo == cul
              );
              const cultivosDays = this.allDays.map(day => {
                const actualDay = cultivosValues.find(d => d.fecha == day);
                return {
                  fecha: day,
                  total: actualDay ? Number(actualDay.valor.toFixed(2)) : 0
                };
              });
              // console.log(cultivosDays);
              const dataCultivo = cultivosDays.map(day => {
                return day.total;
              });
              dataSetsValues.push({
                label: cul,
                data: cultivosDays
              });
              // dataSets.push({ cultivo: cul, dataSet: dataCultivo });
              dataSets.push({
                data: dataCultivo,
                backgroundColor: this.colorGen(),
                label: cul
              });
            });

            const cultivosHeaders = cultivos.map(item => {
              return {
                key: item.replace(" ", ""),
                label: item,
                _style: "width:10%"
              };
            });
            this.fields = [...this.fieldsEgresosCultivoDia, ...cultivosHeaders];
            this.data = dataSets;

            // console.log(dataSetsValues);
            this.allDays.forEach(day => {
              let rowTable = {
                fecha: day
              };
              cultivos.forEach(cul => {
                const actualCult = dataSetsValues.find(
                  item => item.label == cul
                );
                if (actualCult) {
                  const totalDay = actualCult.data.find(
                    val => val.fecha == day
                  );
                  totalDay
                    ? (rowTable = {
                        ...rowTable,
                        [cul.replace(" ", "")]: `$${String(
                          totalDay.total
                        ).replace(/\B(?=(\d{3})+(?!\d))/g, `,`)}`
                      })
                    : (rowTable = {
                        ...rowTable,
                        [cul.replace(" ", "")]: "$0"
                      });
                }
              });
              tableValues.push(rowTable);
            });
            // console.log(tableValues);
            this.egresosDiaTabla = tableValues;
            this.isLoadingGraph = false;
          })
          .catch(err => {
            if (err !== "Stop") {
              this.isLoadingGraph = false;
            }
          });
      }
    },
    fetchCombos() {
      this.isLoadingPage = true;
      // // console.log(moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59"));
      // if (!this.ubicacionesRaiz.length) {
      const ubi = [
        this.$store.dispatch('customHTTP', {
          schema: 'configuracion',
          filter: {
            where: [{field: 'payload->parametro', value: 'cultivos', operator: '='}]
          }
        }),
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->pertenece_id",
                value: 0,
                operator: "="
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        }),
        this.$store.dispatch("customHTTP", { schema: "cultivos" }),
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->raiz_id",
                value: this.ubicacionRaiz,
                operator: "="
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];
      Promise.all(ubi)
        .then(([configuracion, ubicaciones, cultivos, ubicacionesAll]) => {
          // console.log(ubicaciones.data);
          this.ubicaciones = ubicaciones.data.map(ubi => {
            return { value: ubi.id, label: ubi.payload.nombre };
          });
          this.cultivos = configuracion.data[0].payload.valor.map((cultivo,) => {
            return {label: cultivo.nombre, value: cultivo.nombre, embalajes: cultivo.embalajes }
          })
          this.variedades = cultivos.data.map(cultivo => {
            return { value: cultivo.id, label: cultivo.payload.variedad, cultivo: cultivo.payload.nombre};
          }).filter(variedad => {
            return variedad.label != undefined
          });
          this.ubicaciones2 = ubicacionesAll.data.map(ubi => {
            return { value: ubi.id, label: ubi.payload.nombre };
          });
          // console.log(values);
          // this.ubicaciones = ubicaciones.data;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoadingPage = false));
    },
    updateValues() {
      // this.updateGraphs();
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        // console.log("funciona");
        // this.updateItemsSearch(this.filter.toUpperCase());
        // this.updateInfo();
        this.isLoteActive
          ? this.updateValuesLote()
          : this.updateValuesCultivo();
      }, 800);
    },
    changeGrapgh(value) {
      if (value) {
        this.actualGraph = value;
      }
    },
    colorGen() {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      return "rgb(" + r + "," + g + "," + b + ", 0.9)";
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Stop");
        // console.log("cancel request done");
      }
    },
    changeDate(e) {
      console.log(e);
      const datesValues = [
        moment(e.start).format("YYYY-MM-DD"),
        moment(e.end).format("YYYY-MM-DD")
      ];
      this.$store.dispatch("setDateGraph", datesValues);
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.txt-purple {
  color: #321fdb;
}
.txt-green {
  color: #2eb85c !important;
}
.txt-red {
  color: #e55353 !important;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.dropdown-sp {
  width: 400px;
}
.cursor-p {
  cursor: pointer;
}

.root-location {
  width: 180px;
  margin: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selector-input {
  width: 180px;
  margin-left: 0.5rem;
}
.selector-input-2 {
  width: 180px;
  margin: 0 0.5rem;
}
.root-location-input {
  width: 100%;
}
.margi-dates {
  margin: 0 0.5rem;
}
.sp-margin-b {
}
.sp-margin-ul {
}
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
/* .btn-header {
  max-width: 120px;
} */
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
@media (max-width: 700px) {
  .selector-input {
    width: 180px;
    margin-left: 0.5rem;
  }
  .selector-input-2 {
    width: 200px;
    margin: 0 0.5rem;
  }
  .margi-dates {
    margin: 0 0.4rem;
  }
}
@media (max-width: 620px) {
  .selector-input {
    width: 200px;
    margin-right: 0.4rem;
  }
  .selector-input-2 {
    width: 200px;
    margin: 0.4rem;
  }
}
@media (max-width: 580px) {
  .margi-dates {
    margin: 0 0.3rem;
  }
  .selector-input {
    margin-top: 0.4rem;
    margin-bottom: 0.2rem;
  }
}
@media (max-width: 450px) {
  .root-location {
    width: 120px;
    margin: 0 0.2rem;
  }
  .sp-margin-b {
    margin-left: 0.5rem !important;
  }
  .sp-margin-ul {
    margin-right: 0.5rem !important;
  }
}
@media (max-width: 360px) {
  .root-location {
    width: 100px;
    margin: 0 0.2rem;
  }
  .sp-font-size {
    font-size: 10px;
    font-weight: 400;
  }
  .sp-margin-b {
    margin-left: 0.1rem !important;
  }
  .sp-margin-ul {
    margin-right: 0.1rem !important;
  }
  .clave {
    font-size: 11px;
  }
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
